var map = {
	"./tab_music_icon.svg": "fba0",
	"./tab_music_select_icon.svg": "ea91",
	"./tab_sound_icon.svg": "1904",
	"./tab_sound_select_icon.svg": "21c8",
	"./tab_video_icon.svg": "cab9",
	"./tab_video_select_icon.svg": "e2ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b66";